export const FETCH_SEARCH_SUGGESTIONS_REQUEST =
  'FETCH_SEARCH_SUGGESTIONS_REQUEST';
export const FETCH_SEARCH_SUGGESTIONS_FAILURE =
  'FETCH_SEARCH_SUGGESTIONS_FAILURE';
export const FETCH_SEARCH_SUGGESTIONS_SUCCESS =
  'FETCH_SEARCH_SUGGESTIONS_SUCCESS';
export const CLEAR_SEARCH_SUGGESTIONS = 'CLEAR_SEARCH_SUGGESTIONS';
